import dayjs from 'dayjs';

// Whole-day distance rounded up so a signing with ~36h until expiry still
// reads "2 days" instead of "1 day". Clamped to ≥0 to avoid negative deltas
// surfacing in UI copy if a deadline just passed.
export const daysUntil = (iso: string): number =>
  Math.max(0, Math.ceil(dayjs(iso).diff(dayjs(), 'hour') / 24));

export const daysSince = (iso: string): number =>
  Math.max(0, Math.ceil(dayjs().diff(dayjs(iso), 'hour') / 24));
